var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInjuredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set-Strategy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Strategy-Final-|-Player-Added-+-Player's-List-(After-Dragging)-(Desktop)",
    transform: "translate(-574.000000, -704.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-52",
    transform: "translate(265.000000, 271.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    transform: "translate(309.000000, 433.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6160676,8.46071285 L11.7303557,8.46071285 L11.7303557,5.38392841 C11.7303557,5.1718906 11.5584652,5 11.3464275,5 L8.84642953,5 C8.63439181,5 8.46250128,5.1718906 8.46250128,5.38392841 L8.46250128,8.46071285 L5.38393241,8.46071285 C5.28179816,8.46071174 5.18387291,8.50140626 5.11182084,8.57379348 C5.03976877,8.64618071 4.99952912,8.74429378 5,8.84642697 L5,11.3464259 C5,11.5584637 5.17189469,11.7303543 5.38393241,11.7303543 L8.46071557,11.7303543 L8.46071557,14.6160674 C8.46071446,14.7182017 8.50140896,14.816127 8.57379616,14.8881791 C8.64618335,14.9602312 8.74429638,15.0004709 8.84642953,15 L11.3464275,15 C11.5584652,15 11.7303557,14.8281052 11.7303557,14.6160674 L11.7303557,11.7303543 L14.6160676,11.7303543 C14.8281053,11.7303543 15,11.5584637 15,11.3464259 L15,8.84642697 C15.0004709,8.74429378 14.9602312,8.64618071 14.8881792,8.57379348 C14.8161271,8.50140626 14.7182018,8.46071174 14.6160676,8.46071285 Z",
    id: "Path",
    fill: "#DE3E32",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjuredIcon);
export default __webpack_public_path__ + "static/media/injured-icon.610425edbe9622da96a7403aceb9f77a.svg";
export { ForwardRef as ReactComponent };